<!-- title -->
<app-modal-title
  [title]="'common.checkCell' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  @if(loading){
  <div
    class="text-primary tw-text-lg tw-font-medium tw-mx-2"
    [innerHTML]="'common.checkingPleaseWait' | translate"
  ></div>
  <div class="tw-max-w-[600px] sm:tw-min-h-[220px] tw-min-h-[150px]">
    <div
      class="tw-flex-center tw-space-x-3 tw-space-x-reverse tw-mt-14"
    >
      <div class="tw-animate-pulse tw-flex">
        <div
          class="tw-bg-gray-200 dark:tw-bg-gray-700 tw-h-[100px] tw-w-[100px] tw-rounded-lg"
        ></div>
      </div>

      <div class="tw-animate-pulse tw-flex">
        <div
          class="tw-bg-gray-200 dark:tw-bg-gray-700 tw-h-[100px] tw-w-[100px] tw-rounded-lg"
        ></div>
      </div>

      <div class="tw-animate-pulse tw-flex">
        <div
          class="tw-bg-gray-200 dark:tw-bg-gray-700 tw-h-[100px] tw-w-[100px] tw-rounded-lg"
        ></div>
      </div>
      <span></span>
    </div>
  </div>

  } @else {
  <div class="tw-h-full tw-max-w-[600px] tw-min-h-[310px] tw-max-h-[60vh]">
    @if (items?.length) {
    <div class="tw-flex radio-btns tw-flex-center tw-w-full">
      @for (item of items; track $index; let last = $last) {
      <div class="radio-btn tw-flex-center tw-flex-col tw-mt-10">
        <label
          [ngClass]="item.isHaveCells ? 'check' : 'close'"
          class="tw-bg-gray-50 dark:tw-bg-dark-200 tw-border-[#bcc2bf] dark:tw-border-dark-100 tw-content"
        >
          <img
            [src]="getSmsAggregatorImg(item?.mobileOperator)"
            class="tw-w-20"
          />
        </label>

        <!-- operator name -->
        <span
          class="tw-font-bold tw-mt-2 tw-text-[16px] tw-text-primary-800 dark:tw-text-gray-300"
        >
          @switch (item?.mobileOperator) { @case (SmsAggregator.Irancell) {
          {{ "enums.SmsAggregator.Irancell" | translate }}
          } @case (SmsAggregator.MCI) {
          {{ "enums.SmsAggregator.MCI" | translate }}
          } @case (SmsAggregator.Rightel) {
          {{ "enums.SmsAggregator.Rightel" | translate }}
          } @case (SmsAggregator.NotValid) {
          {{ "enums.SmsAggregator.NotValid" | translate }}
          } @case (SmsAggregator.Other) {
          {{ "enums.SmsAggregator.Other" | translate }}
          } }
        </span>
      </div>
      }
    </div>
    } @else {
    <span class="tw-text-2xl">
      {{ "common.empty" | translate }}
    </span>
    }
  </div>

  }
</div>
